<template>
    <div :class="['fs5-shared-collapse', collapsed ? 'collapsed' : '']">
        <div class="fs5-collapse-header" @click="collpaseToggle">
            <div>
                <i :class="['fa fa-chevron-down', !collapsed ? '' : 'rotate-180']" ></i>
            </div>
            <div>
                <slot name="title" :title="view.title" :title-class="`fs5-collapse-header-title`">
                    <span class="fs5-collapse-header-title" >{{view.title}}</span> <!-- default value -->
                </slot>
            </div>
        </div>
        <div class="fs5-collapse-content section" :class="{ 'collapsed': !collapsed }">
            <slot name="content" :content="view.content">
                <div id="div_exemplo">{{view.content}}</div> <!-- default value -->
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'fs5-shared-collapse',
        props: {
            view: {
                type: Object,
                default: function () {
                    return {
                        title: 'My Stuff',
                        content: 'Your component here'
                    }
                }
            }
        },
        data: function() {
            return {
                collapsed: true,
                nameCollapse: 'collapse-status'
            }
        },
        mounted() {
          this.collapsed = !localStorage.getItem(this.nameCollapse) || localStorage.getItem(this.nameCollapse) == "true";
        },
        methods: {
            collpaseToggle(){
                this.collapsed = !this.collapsed
                localStorage.setItem(this.nameCollapse, this.collapsed)
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables';
    .section {
        overflow: hidden;
        transition: max-height .8s;
        height: auto;
        max-height: 1800px;
    }
    .section.collapsed {
        transition: .8s;
        max-height:0;
        padding: 0 0 !important;
    }
    .fs5-shared-collapse{
        font: inherit;
        display: flex;
        flex-direction: column;

        .fs5-collapse-header{
            font: inherit;
            background-color: $fs5-color3;
            border-radius: 0.8em;
            border: 1px $fs5-color1 solid;
            padding:  1.6em 4.5em;
            display: flex;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-items: center;
            column-gap: 1em;

            &:hover{
                cursor: pointer;
            }
            div{
                font: inherit;
                .fs5-collapse-header-title{
                    font: inherit;
                    font-size: 1.8em;
                    color: $fs5-color2;
                    font-weight: 800;
                    text-transform: capitalize;
                    margin-right: 0.777777778em;
                    display: inline-block;
                    transition: color .3s ease-in-out;
                }
                i{
                    font-size: 1.4em;
                    color: $fs5-color2;
                }
            }
        }

        .fs5-collapse-content{
            font: inherit;

            padding: 0.5em 0;
        }

        &.collapsed{
            .fs5-collapse-header{
                background-color: $fs5-color2;
                div{
                    .fs5-collapse-header-title{
                        color: $fs5-color5;
                    }
                    i{
                        color: $fs5-color5;
                    }
                }
            }
        }
    }

    .text-primary{
        color: $fs5-color5!important;
    }
    .rotate-180{
        transform: rotate(180deg);
    }
    .fa-chevron-down{
        transition: transform .3s ease-in-out;
    }
    @media (max-width: 700px) {
        .fs5-shared-collapse {
            padding: 1.4em 0 0em 0;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/tools/collapse/Collapse.vue